import { Component, Input } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MessageDialogData } from "./message-dialog-data";
import { DialogBase } from "../dialog-base";

@Component({
    standalone: false,
    selector: 'message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent extends DialogBase<MessageDialogComponent, MessageDialogData> {
}
